import React from 'react';
//import { Route } from 'react-router';
import { Redirect, Route } from "react-router-dom";


export const PrivateRoute = ({ component: Component, roles, ...rest }) => (
	   

    <Route {...rest} render={props => {
        //const currentUser = authenticationService.currentUserValue;
    	const currentUser = localStorage.getItem('user');
        if (!currentUser) {
            // not logged in so redirect to login page with the return url
            return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
        	
        }
        
        const assignedRoles = JSON.parse(localStorage.getItem('assignedRoles'));
       
        // check if route is restricted by role
        if (roles && !assignedRoles.includes(roles[0])) {
        	console.log("roles: " + roles);
        	console.log("Assigned.roles: " + assignedRoles);
        	console.log("index: " + roles.indexOf(assignedRoles));
        	
            // role not authorised so redirect to home page
            return <Redirect to={{ pathname: '/applications'}} />
        	 	 
        }

        // authorised so return component
        return <Component {...props} />
    }} />
)